import router, { asyncRoutes, constantRoutes, resetRouter } from '@/router'
// import Layout from '@/layout/index.vue'
import Page404 from '@/views/error-page/404.vue'
import store from '@/store'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      if (roles.includes('超级管理员') || (store.state.user && store.state.user.admin_id == 1)) {
        accessedRoutes = asyncRoutes || []
      } else {
        // accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
        accessedRoutes = []
      }

      const routesFromServer = filterAsyncRouter(store.state.user.routes)
      if (routesFromServer.length > 0) accessedRoutes = routesFromServer.concat(accessedRoutes)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },

  async refreshRoutes({ dispatch }) {
    const { roles } = await store.dispatch('user/getInfo')
    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await store.dispatch('permission/generateRoutes', [], { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)
    console.log('refreshRoutes', accessRoutes)
  }
}

const components = getComponents() // 获取所有组件路径
/**
 * 将 用户菜单JSON信息 转换为 router 可识别的路由json信息
 * @param t 管理员菜单JSON数组
 * @returns {*}
 */
function filterAsyncRouter(t) {
  t.filter(index => {
    // if (index.component === 'Layout' || index.component === 'layout/Layout') {
    //   index.component = Layout
    // } else {
      // 不是路由菜单，转换对应 vue组件
      // @/views/sn-manage/dict/index
      const component = index.component
      console.info(component)
      //
      /**
       * 截取 示例 @/views/sn-manage/dict/index 截取出 @/viesw/ 以外的字符，因为 拼接会异常
       * 新逻辑： 创建页面的时候去掉 @/viesw/
       * @type {*|string}
       * let test = component.substr(find(component, '/', 1) + 1)
       */
      // 判断组件存在，则添加，否则指向404
      if(typeof component === 'string'){
        if (components.find(x => x.path === component)) {
          index.component = require(`@/${component}.vue`).default
        } else {
          index.component = Page404
        }
      }
    // }
    // 递归子菜单
    if (index.children && index.children.length) {
      index.children = filterAsyncRouter(index.children)
    }
    return true
  })
  return t
}

function getComponents() {
  const routerArr = []

  // 查找views目录，以.vue结尾的文件，查找子目录
  const contexts = require.context('@/views/', true, /\.vue$/)

  contexts.keys().forEach(value => {
    const path = value.substr(value.indexOf('/'), value.lastIndexOf('.') - 1)
    const componentLocation = value.substr(value.indexOf('.') + 1, value.lastIndexOf('.') - 1)
    const componentName = componentLocation.substr(componentLocation.lastIndexOf('/') + 1)
    // 添加到路由数组中
    routerArr.push({
      path: `views${path}`,
      name: componentName
      // component: () => import(`@/views${componentLocation}`)
    })
  })

  return routerArr
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
